import { AxiosResponse, AxiosStatic } from 'axios'
import { AuthModel } from 'components/types'
import { AppSettings } from 'components/types/types'
import jwt_decode from "jwt-decode";
import { type } from 'os';

const AUTH_LOCAL_STORAGE_KEY = 'innov-match-k'

export type jwtToken = {
  "primarysid": string,
  "role": string,
  "nbf": number,
  "exp": number,
  "iat": number
}


const getAuth = (a?: string): AuthModel | null => {
  if (!localStorage) {
    return null
  }



  const localStorageValue: string | null = localStorage.getItem(AUTH_LOCAL_STORAGE_KEY)
  if (!localStorageValue) {
    return null
  }

  try {
    const auth: AuthModel = JSON.parse(localStorageValue) as AuthModel
    if (auth) {
      var decoded = jwt_decode<jwtToken>(auth.jwtToken);
      var exp = new Date(decoded.exp * 1000);
      if (exp < new Date()) {
        
        return null
      }
      
      return auth
    }
  } catch (error) {
    console.error('AUTH LOCAL STORAGE PARSE ERROR', error)
  }
  return null
}

const setAuth = (auth: AuthModel) => {
  if (!localStorage) {
    return
  }

  try {
    const localStorageValue = JSON.stringify(auth)
    localStorage.setItem(AUTH_LOCAL_STORAGE_KEY, localStorageValue)
  } catch (error) {
    console.error('AUTH LOCAL STORAGE SAVE ERROR', error)
  }
}

const removeAuth = () => {
  if (!localStorage) {
    return
  }

  try {
    localStorage.removeItem(AUTH_LOCAL_STORAGE_KEY)
  } catch (error) {
    console.error('AUTH LOCAL STORAGE REMOVE ERROR', error)
  }
}

export function setupAxios(axios: AxiosStatic) {
  axios.defaults.headers.common.Accept = 'application/json'
  axios.interceptors.request.use(async (config) => {
    const auth = getAuth()
    const uninterceptedAxiosInstance = axios.create();
    const baseUrl = await uninterceptedAxiosInstance.get(`${window.location.origin}/appSettings.json`)
      .then(({ data }: AxiosResponse<AppSettings>) => {
        return data.baseUrl;
      })

    config.baseURL = baseUrl;

    if (auth && auth.jwtToken && config.headers) {
      config.headers.Authorization = `Bearer ${auth.jwtToken}`
    }

    return config
  },
    (err: any) => Promise.reject(err)
  )
}

export { getAuth, setAuth, removeAuth, AUTH_LOCAL_STORAGE_KEY }